module.exports = __webpack_public_path__ + "img/3.5269ac91.png";